import { d2 } from './decorators/d2';
import { d3 } from './decorators/d3';
import { d8 } from './decorators/d8';
import { w1 } from './decorators/w1';

/**
 * Logger decorator collection
 *
 * @example
 * @loggerDecorator.debug.d3()
 * syncMethod() {
 *  // Sync method code
 * }
 *
 * @loggerDecorator.debug.d3({ message: 'Custom message' })
 * async asyncMethod() {
 *  // Async method code
 * }
 */
export const loggerDecorator = {
  /**
   * Debug-level logging decorators
   */
  debug: {
    /* D2 method decorator for logging method start */
    d2: d2,
    /* D3 method decorator for logging method completion */
    d3: d3,
    /* D8 method decorator for logging not implemented method */
    d8: d8
  },

  /**
   * Warning-level logging decorators
   */
  warn: {
    /* W1 method decorator for logging feature deprecation */
    w1: w1
  }
};
